import { Injectable, inject } from '@angular/core';
import { Router, UrlTree, CanActivate } from '@angular/router';
import { AuthProvider } from '../../features/auth/shared/auth-provider';

/**
 * AuthGuard — protección de rutas administrativas (`/panel/*`).
 *
 * Vive en `src/shared` porque la administración es un feature propio y la
 * protección de enrutado es infraestructura transversal: la ruta ```panel```
 * registra la clase en su arreglo `canActivate` (resuelta por DI).
 *
 * Sin sesión se redirige a /login devolviendo un UrlTree: el router ejecuta
 * la redirección de forma atómica, sin una segunda navegación.
 *
 * ⚠️ SOLO protege las rutas donde se registra (panel/*). El viewer y el resto
 * de rutas públicas quedan fuera de este guard.
 */
@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
  private readonly auth = inject(AuthProvider);
  private readonly router = inject(Router);

  async canActivate(): Promise<boolean | UrlTree> {
    await this.auth.notifier.ensureSessionValidated();
    if (this.auth.state().isAuthenticated) {
      return true;
    }
    return this.router.createUrlTree(['/login']);
  }
}
